/**
 * Sanitizes a telephone number by removing non-numeric characters.
 *
 * @param {string} number - The telephone number to sanitize.
 * @returns {string} - The sanitized telephone number containing only digits.
 */
export default function sanitizeTelNumber(number: string): string {
  // Decode percent-encoded characters
  try {
    number = decodeURIComponent(number);
  } catch (error) {
    console.warn('Failed to decode URL:', error);
    // Remove percent-encoded sequences on failure
    number = number.replace(/%[0-9A-Fa-f]{0,2}/g, '');
  }

  // Extract the phone number part before any tel: URL parameters
  // tel: URLs can have parameters like ;ext=123, ;pause=2, etc.
  const phoneNumberMatch = number.match(/^([^;]+)/);
  const phoneNumberPart = phoneNumberMatch ? phoneNumberMatch[1] : number;

  // Sanitize the phone number part
  const sanitizedNumber = phoneNumberPart
    .replace(/\s+/g, '') // Remove all whitespace
    .replace(/[^\d+]/g, '') // Keep only digits and + symbol
    .replace(/^\+/, '+') // Ensure + is at the beginning if present
    .replace(/^\+{2,}/, '+'); // Remove multiple + symbols, keep only one

  console.log('ProtocolHandlerService: Original number:', number, 'Sanitized number:', sanitizedNumber);
  return sanitizedNumber;
}
